import API from '@/services/API'

export default {
	// API Functions
	async getSchools () {
		try {
			const response = await API.get('school/index')
			return response.data.schools
		} catch (err) {
			console.log(err)
		}
	},
	async getPrograms (schoolId) {
		try {
			const response = await API.get(`school/${schoolId}/programs`)
			return response.data.programs
		} catch (err) {
			console.log(err)
		}
	},
	async getCourses (programId) {
		try {
			const response = await API.get(`program/${programId}/courses`)
			return response.data.courses
		} catch (err) {
			console.log(err)
		}
	},
	// Local functions
	getYearCourses (year, courses) {
		var yearCourses = []
		courses.forEach(function (course) {
			if (course.year === year) yearCourses.push(course)
		})
		return yearCourses
	},
	getCourseYears (courses) {
		var courseYears = []
		courses.forEach(function (course) {
			if (!courseYears.includes(course.year)) courseYears.push(course.year)
		})
		return courseYears.sort()
	},
	getCoursePeriods (courses) {
		var coursePeriods = []
		courses.forEach(function (course) {
			if (!coursePeriods.includes(course.period)) coursePeriods.push(course.period)
		})
		return coursePeriods.sort()
	},
	getPeriodCourses (period, courses) {
		var periodCourses = []
		courses.forEach(function (course) {
			if (course.period === period) periodCourses.push(course)
		})
		return periodCourses
	}
}
